import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DialogRef, KENDO_DIALOGS } from '@progress/kendo-angular-dialog';
import { TranslationPipe } from '@raptor-fe/services';
import { SystemAnnouncement, SystemAnnouncementType } from '@raptor-fe/core';

@Component({
    selector: 'lib-system-announcement-details-modal',
    template: `
        <kendo-dialog width="600px" (close)="onClose()">
            <kendo-dialog-titlebar>
                <span class="d-flex align-items-center">
                    @if (announcement().type === announcementType.WhatIsNew) {
                        <i class="bi bi-rocket-takeoff me-2"></i>
                    } @else {
                        <i class="bi bi-megaphone me-2"></i>
                    }
                    <h6 class="mb-0">{{ announcement().title }}</h6>
                </span>
            </kendo-dialog-titlebar>

            <p class="mb-0 text-body" style="white-space: pre-wrap;">{{ announcement().description }}</p>

            <kendo-dialog-actions layout="end">
                <button class="btn btn-sm btn-secondary min-w-24" (click)="onClose()">
                    {{ { feature: 'Common', component: 'Button', label: 'Close' } | translate }}
                </button>
            </kendo-dialog-actions>
        </kendo-dialog>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslationPipe, KENDO_DIALOGS],
})
export class SystemAnnouncementDetailsModalComponent {
    protected readonly dialogRef = inject(DialogRef);
    protected readonly announcementType = SystemAnnouncementType;

    announcement = input.required<SystemAnnouncement>();

    protected onClose(): void {
        this.dialogRef.close();
    }
}
